import {branchPath} from '@github-ui/paths'
import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {useChildRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {testIdProps} from '@github-ui/test-id-props'
import {BranchName, RelativeTime} from '@primer/react'

import {repoStackDetailRoute} from '../../routes/repo-stack-detail-route'
import {StackAuthors} from './StackAuthors'
import {StackDetailActions} from './StackDetailActions'
import styles from './StackDetailHeader.module.css'
import stacksStyles from './Stacks.module.css'

export function StackDetailHeader({showSidebar}: {showSidebar: boolean}) {
  const {owner, repo} = useRouteParams(repoStackDetailRoute)
  const {data} = useChildRouteQuery(repoStackDetailRoute, 'mainQuery')
  const stack = data?.stack
  if (!stack && !showSidebar) return null
  const pullRequests = stack?.size === 1 ? '1 pull request' : `${stack?.size} pull requests`

  return (
    <div className={styles.Header} {...testIdProps('stack-detail-header')}>
      <div className={styles.TitleRow}>
        {showSidebar && (
          <div className="hide-lg hide-xl">
            <SidebarPageLayout.SidebarTrigger />
          </div>
        )}
        {stack && <h1 className={styles.Title}>Stack #{stack.number}</h1>}
      </div>
      {stack && (
        <>
          <div className={styles.Actions}>
            <StackDetailActions />
          </div>
          <div className={styles.Meta}>
            <StackAuthors /> <span>stacked {pullRequests} targeting</span>{' '}
            <BranchName href={branchPath({owner, repo, branch: stack.baseRefName})} className={stacksStyles.BranchName}>
              {stack.baseRefName}
            </BranchName>{' '}
            <span aria-hidden="true">&middot;</span> <span>Created</span>{' '}
            <RelativeTime date={new Date(stack.createdAt)} />
          </div>
        </>
      )}
    </div>
  )
}
